(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskListFilter',
	};

	var form_id = 'tasklistfilter-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var entity_type = $('#' + form_id + 'classification').val();

		// init typeaheads
		Adzuki.TaskManager.initTaskTypeaheads(form_id, false, false);

		// show typeahead if a reference was specified
		if (entity_type) {
			$(form.element).find('.' + entity_type + '-typeahead').removeClass('hidden');

			// an entity id was selected, show button to reset it
			if ($('#' + form_id + entity_type + '_id').val() !== '') {
				$(form.element).find('.reset-' + entity_type + '-typeahead').removeClass('hidden');
			}
		}

		// changing the task reference
		$('#' + form_id + 'classification').change(function onClassificationChange(e)
		{
			var entity_type   = $('#' + form_id + 'classification').val();
			var task_entities = Adzuki.TaskManager.entities.slice();

			// reset the typeaheads
			$.each(task_entities, function onEachEntity(i, entity) {
				$('.reset-' + entity + '-typeahead').trigger('click');
			});

			// hide the entity typeahead fields
			$.each(task_entities, function onEachEntity(i, entity) {
				$('.' + entity + '-typeahead').addClass('hidden');
			});

			if (entity_type !== '') {
				$('.' + entity_type + '-typeahead').removeClass('hidden');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
